
import { createElement } from "rax";
import * as Dinamic from "@ali/dinamic";
import { FrameLayout } from "@ali/dinamic-views-icbu-fork";


import {setIndexMapContext} from '../utils/index';
import { getDXDotObject, checkPCP4PDot} from '../utils/dot';

class NewFrameLayout extends FrameLayout {
 
  
  render() { 
    const props = this.props;
    // 渲染前绑定上下文，使所有控件均可在渲染结束后调用 calc
    setIndexMapContext.call(this);
    const {accessibilityText, onTap} = props;
    const dotObject = getDXDotObject(props);
    
    if (dotObject.href) {
      return (<a
        data-logtype={dotObject.type? dotObject.type: 'otherlink'}
        data-params={dotObject.params}
        key={props._id}
        view-name={"SeoFrameLayout"}
        style={this.getStyles()}
        {...this.getAttrs()}
        href={dotObject.href}
        title={accessibilityText}
        target={Dinamic.utils.env.isPC?"_blank":"_self"}
        onClick={(event)=>{
          checkPCP4PDot(dotObject);
          if(!Dinamic.utils.env.isPC){
            event.preventDefault();
          }
        }}
      >
        {this.renderView && this.renderView(props)}
      </a>);
    }

    return (
      <div
        key={props._id}
        view-name={this.getViewName()}
        style={this.getStyles()}
        {...this.getAttrs()}
        data-logtype={dotObject.type? dotObject.type: null}
        data-params={onTap && dotObject.type ? dotObject.params: null}
        onClick={()=>{
          // PC广告品 需要前端发起付费请求
          checkPCP4PDot(dotObject);
        }}
      >
        {this.renderView && this.renderView(props)}
      </div>
    );
  }
}


Dinamic.registerView('FrameLayout', NewFrameLayout);
Dinamic.registerView('DFrameLayout', NewFrameLayout);

export default NewFrameLayout;
